import { useAtom } from "jotai";
import { savedFiltersAtom } from "./atoms";

export function useSavedFilters() {
  const [{ data, isLoading, isFetching, error, refetch }] =
    useAtom(savedFiltersAtom);
  return {
    savedFilters: data,
    isLoading,
    isFetching,
    isSavedFiltersLoading: isLoading || isFetching,
    error,
    loadSavedFilters: refetch,
    savedFilterIds:
      data?.accessibility_preferences[0]?.user_accessibility_preferences?.map(
        (pref) => pref.tag_id
      ) || [],
  };
}
